import { render } from "./App.vue?vue&type=template&id=60e07774"
const script = {}

import "./App.vue?vue&type=style&index=0&id=60e07774&lang=css"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__